import { PropsWithChildren, ReactNode, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Grid, IconButton } from "@mui/material"
import { faCircleXmark } from "@fortawesome/pro-thin-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { CreateOrderDialogFlow, CreateOrderFlowType } from "../createOrderTypes"

import { CreateOrderCloseConfirmDialog } from "./CreateOrderCloseConfirmDialog"

export const CREATE_ORDER_TOP_BAR_HEIGHT = "4.625rem"
export const CREATE_ORDER_TOP_BAR_WITH_BOTTOM_ROW_HEIGHT = "8.25rem"

const useStyles = makeStyles()((theme) => ({
    headerWrap: {
        padding: "0.75rem",
        paddingLeft: ".5rem",
        background: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[400]}`,
        height: CREATE_ORDER_TOP_BAR_HEIGHT,
    },
    headerWithBottomRow: {
        height: CREATE_ORDER_TOP_BAR_WITH_BOTTOM_ROW_HEIGHT,
    },
    closeIcon: {
        color: theme.palette.tailwind.slate[600],
        fontSize: "2rem",
    },
    classNameOverride: {
        padding: "1.25rem 1.5rem 3.25rem",
    },
}))

type CreateOrderDialogTitleProps = Readonly<
    PropsWithChildren<{
        handleClose: () => void
        isDirtyForm?: boolean
        flowConfig?: CreateOrderDialogFlow
        bottomRow?: ReactNode
    }>
>

export function CreateOrderDialogTitle({
    handleClose,
    isDirtyForm = false,
    children,
    flowConfig,
    bottomRow,
}: CreateOrderDialogTitleProps) {
    const { classes, cx } = useStyles()
    const [showConfirmModal, setShowConfirmModal] = useState(false)

    return (
        <>
            <Grid
                container
                className={cx(classes.headerWrap, !!bottomRow && classes.headerWithBottomRow)}
                alignItems="center"
                alignContent={bottomRow ? "center" : undefined}
                justifyContent="space-between"
                flexWrap={bottomRow ? "wrap" : "nowrap"}
                gap=".5rem"
            >
                {flowConfig?.flow !== CreateOrderFlowType.OUTLOOK && (
                    <IconButton onClick={() => (isDirtyForm ? setShowConfirmModal(true) : handleClose())}>
                        <FontAwesomeIcon icon={faCircleXmark} className={classes.closeIcon} />
                    </IconButton>
                )}
                {children}
                {bottomRow && <Box width="100%">{bottomRow}</Box>}
            </Grid>
            {showConfirmModal && (
                <CreateOrderCloseConfirmDialog
                    open={showConfirmModal}
                    onClose={() => setShowConfirmModal(false)}
                    onDiscard={handleClose}
                />
            )}
        </>
    )
}
